import { useMemo } from 'react';
import { CustomFieldDto, CustomFieldFilterInput, CustomFieldOptionDto, EntityType, SystemFieldId, useFindCustomFieldsQuery } from 'gql';

export type ReportCustomField = Pick<CustomFieldDto, 'id' | 'name' | 'customFieldType' | 'systemFieldId'> & {
  options: Pick<CustomFieldOptionDto, 'id' | 'name'>[];
};

export const useReportCustomFields = (customFieldsFilter: CustomFieldFilterInput) => {
  const { data: customFieldsData, isFetching: isActivityFieldsFetching } = useFindCustomFieldsQuery({ filter: customFieldsFilter });
  const activityFields = useMemo<ReportCustomField[]>(() => customFieldsData?.customFields ?? [], [customFieldsData?.customFields]);

  const { data: individualsFieldsData, isFetching: isIndividualsFieldsFetching } = useFindCustomFieldsQuery({
    filter: {
      entityTypes: {
        some: {
          entityType: {
            eq: EntityType.Individual
          }
        }
      },
      systemFieldId: {
        neq: SystemFieldId.Team
      }
    }
  });
  const individualFields = useMemo<ReportCustomField[]>(() => individualsFieldsData?.customFields ?? [], [individualsFieldsData?.customFields]);

  const { data: unknownGroupFieldsData, isFetching: isUnknownGroupFieldsFetching } = useFindCustomFieldsQuery({
    filter: {
      entityTypes: {
        some: {
          entityType: {
            eq: EntityType.UnknownGroup
          }
        }
      },
      systemFieldId: {
        neq: SystemFieldId.Team
      }
    }
  });
  const unknownGroupFields = useMemo<ReportCustomField[]>(() => unknownGroupFieldsData?.customFields ?? [], [unknownGroupFieldsData?.customFields]);

  const { data: realityFieldsData, isFetching: isRealityFieldsFetching } = useFindCustomFieldsQuery({
    filter: {
      entityTypes: {
        some: {
          entityType: {
            eq: EntityType.Reality
          }
        }
      }
    }
  });
  const realityFields = useMemo<ReportCustomField[]>(() => realityFieldsData?.customFields ?? [], [realityFieldsData?.customFields]);

  return {
    activityFields,
    isActivityFieldsFetching,
    individualFields,
    isIndividualsFieldsFetching,
    unknownGroupFields,
    isUnknownGroupFieldsFetching,
    realityFields,
    isRealityFieldsFetching
  };
};
